import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './datepicker.css';

export default class PickerFecha extends React.Component{        
    render(){
        return(
            <DatePicker className='control' disabled={this.props.disabled} dateFormat='DD/MM/YYYY' selected={this.props.fechaSeleccionada} onChange={this.props.func_onChange} 
            onBlur={this.props.func_onBlur} onFocus={this.props.func_onFocus}
            todayButton={'Hoy'} placeholderText='dd/mm/aaaa' showWeekNumbers
            showYearDropdown            
            scrollableYearDropdown
            yearDropdownItemNumber={50}/>
        )
    }
}